import { createSlice } from '@reduxjs/toolkit';
import { globalConfig } from '../GlobalConfig';

const initialState = {
    sortOrder: -1,
    sortField: "createdTs",
    sortKey: "-createdTs",
    page: 1,
    offset: 0,
    limit: globalConfig.pageCount + 1, // Default pageCount + 1
    userName: "",
    userPhone: "",
    affiliateUser: "",
    email: "",
    userEmail: "",
    customerPurchaseDate: null,
    customerPurchaseDateFrom: null,
    customerPurchaseDateTo: null
};

const userFiltersSlice = createSlice({
    name: 'userFilters',
    initialState,
    reducers: {
        setSortOrder: (state, action) => { state.sortOrder = action.payload; },
        setSortField: (state, action) => { state.sortField = action.payload; },
        setSortKey: (state, action) => { state.sortKey = action.payload; },
        setPage: (state, action) => { state.page = action.payload; },
        setOffset: (state, action) => { state.offset = action.payload; },
        setLimit: (state, action) => { state.limit = action.payload; },
        setUserName: (state, action) => { state.userName = action.payload; },
        setUserPhone: (state, action) => { state.userPhone = action.payload; },
        setAffiliateUser: (state, action) => { state.affiliateUser = action.payload; },
        setEmail: (state, action) => { state.email = action.payload; },
        setUserEmail: (state, action) => { state.userEmail = action.payload; },
        setCustomerPurchaseDate: (state, action) => { state.customerPurchaseDate = action.payload; },
        setCustomerPurchaseDateFrom: (state, action) => { state.customerPurchaseDateFrom = action.payload; },
        setCustomerPurchaseDateTo: (state, action) => { state.customerPurchaseDateTo = action.payload; },
        resetUserFilters: () => initialState,
    },
});

export const {
    setSortOrder,
    setSortField,
    setSortKey,
    setPage,
    setOffset,
    setLimit,
    setUserName,
    setUserPhone,
    setAffiliateUser,
    setEmail,
    setUserEmail,
    setCustomerPurchaseDate,
    setCustomerPurchaseDateFrom,
    setCustomerPurchaseDateTo,
    resetUserFilters
} = userFiltersSlice.actions;

export default userFiltersSlice.reducer;
